import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useMediaQuery } from 'react-responsive';
import { setNFOappliedFilterList } from './nfo.actions';
import { useDispatch, useSelector } from 'react-redux';
import { propsToJS } from '__utils/immutable-to-js';
import NFOSelector from './nfo.selector';
import { useDeepCompare } from 'hooks/use-deep-memo';
import closeIcon from '../../images/closeIcon.svg';

const PopupCont = styled.div`
    display: block;
    overflow-x: hidden;
    overflow-y: auto;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1050;
    outline: 0;
    transition: opacity .15s linear;
    background: rgba(100, 100, 100, 0.5);
`;

const VerticleAlignedCont = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    -moz-transform: translate(-50%,-50%);
    -webkit-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    width: 100%;
    &.mediaPopup {
        position: fixed;
        top: auto;
        bottom: 0;
        transform: none;
        left: 0;
    }
`;

const ModalOuterCont = styled.div`
    position: relative;
    width: 80%;
    margin: 0 auto;
    transform: scale(1);
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
    -ms-transform: scale(1);
    -webkit-animation-name: zommingEffect;
    -webkit-animation-duration: .3s;
    animation-name: zommingEffect;
    animation-duration: .3s;
    -webkit-transition: -webkit-transform .3s ease-out;
    -o-transition: -o-transform .3s ease-out;
    transition: transform .3s ease-out;

    -webkit-transform: translate(0,-25%);
    -ms-transform: translate(0,-25%);
    -o-transform: translate(0,-25%);
    transform: translate(0,-25%);

    -webkit-transform: translate(0,0);
    -ms-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
`;

const ModalInnerCont = styled.div`
    position: relative;
    background-color: #fff;
    -webkit-background-clip: padding-box;
    background-clip: padding-box;
    border: 1px solid rgba(0,0,0,.2);
    border-radius: 6px;
    outline: 0;
    -webkit-box-shadow: 0 3px 9px rgba(0,0,0,.5);
    box-shadow: 0 3px 9px rgba(0,0,0,.5);
    &.modelInnerContCust:before {
        content: '';
        display: block;
        width: 40px;
        height: 4px;
        border-radius: 2px;
        background-color: #d8d8d8;
        position: relative;
        left: 0;
        right: 0;
        margin: auto;
        top: 4px;
        margin-bottom: 0px;
    }
    .filterType {
        list-style: none;
        margin-bottom:15px;
        li{
            display:flex;
            align-items: center;
            input[type=checkbox]{
                width: 20px;
                height: 20px;
                margin: 8px 16px 8px 0;
                position: relative;
                visibility: hidden;
                cursor: pointer;
                &:after{
                    content: '';
                    position: absolute;
                    width: 20px;
                    height: 20px;
                    color: var(--green);
                    border: 2px solid black;    
                    visibility: visible;
                }
            }
            input:checked:after {
                content: '';
                position: absolute;
                width: 20px;
                height: 20px;
                border: 2px solid #00a465;
            }
            input[type=checkbox]:checked:before {
                content: '✓';
                position: absolute;
                color: #00a465;
                font-weight: bold;
                font-size: 15px;
                visibility: visible;
                left: 3px;
                top: -1px;
            }   
        }
    }
`;


interface PopupProps {
    title?: string,
    closable?: boolean,
    onClose: Function,
    style?: any,
    getFilterValue: any,
    isCheckedFilter?: any
}

const filterData = [
    { id: "1", name: "Open NFO’s" },
    { id: "2", name: "Upcoming NFO’s" },
    { id: "3", name: "Recently Closed NFO’s" },
    { id: "4", name: "Closed & Listed NFO’s" },
]

const FilterPopup: React.FC<PopupProps> = (props: PopupProps) => {

    const dispatch = useDispatch();
    const { nfoAppliedFilterList } = propsToJS(useSelector(NFOSelector));
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const [filterItem, setFilterItem] = useState<any>([]);

    useEffect(() => {
        setFilterItem(filterData);
    }, []);

    useEffect(() => {
        if(nfoAppliedFilterList?.length > 1){
            setFilterItem(nfoAppliedFilterList);
        }
    }, [useDeepCompare(nfoAppliedFilterList)]);

    const onFilterChange = (e: React.ChangeEvent<any>): void => {
        const { name, id, checked } = e.target;
        let tempFilter = [];
        if (name === "All NFO's") {
            tempFilter = filterItem.map((filterBy: any) => {
                return { ...filterBy, isChecked: checked }
            });
            setFilterItem(tempFilter);
        } else {
            tempFilter = filterItem.map((filterBy: any) =>
                filterBy.name === name ? { ...filterBy, isChecked: checked } : filterBy
            );
            setFilterItem(tempFilter);
        }
        const filterCount = tempFilter.filter((obj: any) => obj?.isChecked).length;

    };

    if (props.isCheckedFilter) {
        let valueFilter = Object.entries(props.isCheckedFilter);
        let tempFilter = valueFilter.map((filtterBy: any) => {
            return { ...filtterBy, isChecked: true }

        });
        setFilterItem(tempFilter);
    }

    const applyFilter = () => {
        props?.onClose(false);
        props.getFilterValue(filterItem);
        dispatch(setNFOappliedFilterList(filterItem));
    }

    return (<PopupCont style={props.style}>
        <VerticleAlignedCont className={isMobile ? "mediaPopup" : ""}>
            <ModalOuterCont className={isMobile ? "w100" : "webModelWidth"} onClick={(e) => e.stopPropagation()}>
                <ModalInnerCont className={isMobile ? "modelInnerContCust" : ""}>
                    <div className="p16">
                        <div className='filterHead'>
                            <h4>Filter By</h4>
                            <img onClick={() => props?.onClose(false)} src={closeIcon}/>
                        </div>
                        <div className='filterType'>
                            <li>
                                <input
                                    type="checkbox"
                                    id="0"
                                    name="All NFO's"
                                    onChange={onFilterChange}
                                    checked={filterItem?.filter((filterBy: any) => filterBy?.isChecked !== true).length < 1}
                                />
                                <span><b>All NFO's</b></span>
                            </li>
                            {filterItem.map((filterBy: any, i: any) => (
                                <li key={i}>
                                    <input
                                        type="checkbox"
                                        id={filterBy.id}
                                        name={filterBy.name}
                                        onChange={onFilterChange}
                                        checked={filterBy?.isChecked || false}
                                    />
                                    <span>{filterBy.name}</span>
                                </li>
                            ))}
                        </div>
                        <button className="greenBtn nfoApplyBtn w100 m0" onClick={applyFilter}>Apply</button>
                    </div>
                </ModalInnerCont>
            </ModalOuterCont>
        </VerticleAlignedCont>
    </PopupCont>)
}

FilterPopup.defaultProps = {
    closable: true
}

export default FilterPopup;